/** `data.code` of every refusal the reels, clips and credit routes answer (praycom/server_pray#19207 › Errors). */
export const REEL_ERROR_CODES = {
  notConfigured: 'REELS_NOT_CONFIGURED',
  disabled: 'REELS_DISABLED',
  sourceUnsupported: 'REELS_SOURCE_UNSUPPORTED',
  alreadyRunning: 'REELS_ALREADY_RUNNING',
  unavailable: 'REELS_UNAVAILABLE',
  notRerenderable: 'REELS_NOT_RERENDERABLE',
  invalidCaptions: 'REELS_INVALID_CAPTIONS',
  unsupportedStyle: 'REELS_UNSUPPORTED_STYLE',
  captionTimingLocked: 'REELS_CAPTION_TIMING_LOCKED',
  notFound: 'REELS_NOT_FOUND',
  clipInUse: 'CLIP_IN_USE',
  insufficientCredits: 'INSUFFICIENT_CREDITS',
  confirmationRequired: 'CREDIT_CONFIRMATION_REQUIRED',
  confirmationNotFound: 'CREDIT_CONFIRMATION_NOT_FOUND',
  confirmationUsed: 'CREDIT_CONFIRMATION_USED',
  confirmationExpired: 'CREDIT_CONFIRMATION_EXPIRED',
  confirmationStale: 'CREDIT_CONFIRMATION_STALE',
  nothingToCharge: 'CREDIT_CONFIRMATION_NOTHING_TO_CHARGE',
  brandKitAssetNotThisArtist: 'BRAND_KIT_ASSET_NOT_THIS_ARTIST',
} as const;

export type ReelsApiError = {
  status: number | null;
  code: string | null;
  message: string | null;
  details: Record<string, unknown>;
};

type ErrorEnvelope = { data?: { code?: unknown; message?: unknown; details?: unknown } };

/**
 * A refusal's `data.code`, `data.message` and `data.details` (reels and credit refusals answer
 * `{ responded_at, object, data: { object: "error", code, message, details } }`). Plain errors (validation, 403, 404,
 * 500) answer a list with no code, so they read as `code: null`.
 */
export function readReelsError(error: unknown): ReelsApiError {
  const response = (error as { response?: { status?: number; data?: ErrorEnvelope } })?.response;
  const data = response?.data?.data;
  const details = data?.details;
  return {
    status: typeof response?.status === 'number' ? response.status : null,
    code: typeof data?.code === 'string' ? data.code : null,
    message: typeof data?.message === 'string' ? data.message : null,
    details:
      details && typeof details === 'object' && !Array.isArray(details) ? (details as Record<string, unknown>) : {},
  };
}
